import { ReactElement, useRef, useMemo } from 'react'
import {
  WebsiteLayout,
  useUpdateHeader,
  HEADER_THEMES,
  useCleanHeader,
  AnUniverseInExpansion,
  FromOurBlogSection,
  VideoSection,
  AboutUsHero,
  WebsiteSeo,
  AboutUsOurValues,
  AboutUsTheTrustNeeded,
} from '@platform/website-components'
import { Locale, useGetWebsiteAboutUsPageQuery } from '@platform/data-access'
import { websiteFormatArticleList } from '@platform/utils'

const SEO = {
  title: 'About us // Olby',
  description:
    'We were born to reduce intercultural barriers and to promote thriving work relationships.',
}
export const AboutUs = () => {
  const heroSection = useRef<HTMLElement>(null)
  const videoSection = useRef<HTMLElement>(null)
  const anUniverseInExpansionRef = useRef<HTMLDivElement>(null)
  const ourValuesRef = useRef<HTMLDivElement>(null)
  const theTrustNeededRef = useRef<HTMLElement>(null)
  const fromOurBlogRef = useRef<HTMLDivElement>(null)

  useUpdateHeader(heroSection, HEADER_THEMES.BLURRED)
  useUpdateHeader(videoSection, HEADER_THEMES.BLURRED)
  useUpdateHeader(anUniverseInExpansionRef, HEADER_THEMES.BLURRED)
  useUpdateHeader(ourValuesRef, HEADER_THEMES.BLURRED)
  useUpdateHeader(theTrustNeededRef, HEADER_THEMES.BLURRED)
  useUpdateHeader(fromOurBlogRef, HEADER_THEMES.NEUTRAL_BACKGROUND)
  useCleanHeader()

  const { data } = useGetWebsiteAboutUsPageQuery({ input: { locale: Locale.En } })

  const posts = useMemo(() => {
    if (!data?.getWebsiteAboutUsPage?.data) {
      return []
    }
    const list = data?.getWebsiteAboutUsPage?.data.posts?.map(({ post }) => post)
    const formattedArticles = websiteFormatArticleList(list || [])
    return formattedArticles
  }, [data])

  return (
    <>
      <WebsiteSeo seo={SEO} />
      <AboutUsHero ref={heroSection} />
      <VideoSection ref={videoSection} />
      <AnUniverseInExpansion ref={anUniverseInExpansionRef} />
      <AboutUsOurValues ref={ourValuesRef} />
      <AboutUsTheTrustNeeded ref={theTrustNeededRef} />
      <FromOurBlogSection posts={posts} ref={fromOurBlogRef} />
    </>
  )
}

export default AboutUs

AboutUs.getLayout = (page: ReactElement) => {
  return <WebsiteLayout shouldChangeBgColor>{page}</WebsiteLayout>
}
